<section class="search-filter-container">
	<div class="filter-sorter-container" #filterGroupsContainer>
		<search-sorter
			[currentSortOption]="currentSortOption"
			[sortOptions]="sortOptions"
			[optionsRevealApproach]="optionsRevealApproach"
			(sortChange)="onSortChange($event)"
		></search-sorter>
		<ng-container *ngIf="categories.length > 0">
			<search-filter
				*ngIf="multiSelectCategories; else singleSelectCategories"
				[filterOptions]="convertFilterGroupToFilterOptions(categories)"
				filterTitle="Categories"
				[optionsRevealApproach]="optionsRevealApproach"
				(filterChange)="onCategoryChange($event)"
			></search-filter>
			<ng-template #singleSelectCategories>
				<search-single-select
					[options]="categoryOptions"
					[optionsRevealApproach]="optionsRevealApproach"
					[currentOptionValue]="currentSingleSelectCategoryOptionValue"
					(selectChange)="onSingleCategoryChange($event)"
					prefixTitle="Categories"
					name="categories"
				></search-single-select>
			</ng-template>
		</ng-container>
		<search-toggle-filter
			*ngFor="let option of specialsGroupFilterOptions; trackBy: trackByOptionNameFn"
			[filterOption]="option"
			(filterToggle)="onFilterToggle($event)"
		></search-toggle-filter>
		<search-filter
			*ngFor="let group of filterGroups; trackBy: trackByGroupFn"
			[filterOptions]="convertFilterGroupToFilterOptions(group)"
			[filterTitle]="group[0].group"
			[optionsRevealApproach]="optionsRevealApproach"
			(filterChange)="onFilterChange($event)"
		></search-filter>
	</div>
	<p *ngIf="totalItems !== undefined" class="totalItems">{{ totalItems }} Products</p>
</section>
